/**
 * @param {String} string
 * @param {String} param
 * @return {String}
 */
export function getQueryStringParameter(string, param) {
    const parameters = new URLSearchParams(string);
    return parameters.get(param);
}
